import styled from "styled-components";

const Italic = styled.i`
  font-size: 14px;
  font-style: italic;
  color: rgba(37, 38, 49, 0.6);
  display: inline;
`;

export default Italic;
